import { StyleSheet } from 'react-native';

const homeLoaderStyle = StyleSheet.create({
  mainWrapper: {
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 16
  }
});
export default homeLoaderStyle;
